module.exports = __webpack_public_path__ + "media/images/badges/kinrgy/Kinrgy-1000-Classes-Inactive-54d65b325ded06670bc1ac5dc6257243.png";